import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Seo } from "../components/Seo";
import { Heart, Trash2, ShoppingBag } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { inr, buildLabel } from "../lib/api";

export default function Wishlist() {
  const { wishlist, toggleWishlist, addToCart } = useStore();
  return (
    <div className="container-hw py-10 lg:py-16">
      <Seo title="Your Wishlist | H&W Furniture" description="Your saved H&W Furniture pieces." path="/wishlist" noindex />
      <p className="eyebrow">Saved for later</p>
      <h1 className="t-h1 mt-3">Your wishlist</h1>
      {wishlist.length === 0 ? (
        <div data-testid="wishlist-empty" className="card mt-12 border-dashed p-12 text-center">
          <span className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-sand"><Heart className="h-7 w-7 text-sheesham" /></span>
          <p className="t-h3 mt-5">Nothing saved yet.</p>
          <p className="t-lead mt-2">Tap the heart on any piece to keep it here while you measure the room.</p>
          <Link to="/shop" className="btn-sheesham mt-6">Browse pieces</Link>
        </div>
      ) : (
        <ul className="mt-10 grid gap-4">
          <AnimatePresence initial={false}>
            {wishlist.map((p) => (
              <motion.li layout key={p.slug} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, x: 40 }} data-testid={`wishlist-item-${p.slug}`} className="card flex flex-wrap items-center gap-5 p-4 sm:p-5">
                <Link to={`/product/${p.slug}`} className="render h-24 w-24 shrink-0 rounded-xl sm:h-28 sm:w-28"><img src={p.image} alt={p.name} className="h-full w-full object-cover" /></Link>
                <div className="min-w-[180px] flex-1">
                  <Link to={`/product/${p.slug}`} className="t-h3 hover:text-sheesham">{p.name}</Link>
                  <p className="t-small mt-1">{p.tagline}</p>
                  <p className="t-small mt-1">{buildLabel(p.build_minutes)}{p.variant_name && ` · ${p.variant_name}`}</p>
                </div>
                <div className="text-right">
                  <p className="price text-xl">{inr(p.price)}</p>
                  {p.mrp > p.price && <p className="mrp text-sm">{inr(p.mrp)}</p>}
                </div>
                <div className="flex w-full gap-2 sm:w-auto">
                  <button data-testid={`wishlist-move-to-cart-${p.slug}`} onClick={() => { addToCart(p); toggleWishlist(p); }} className="btn-sheesham flex-1 sm:flex-none"><ShoppingBag className="h-4 w-4" /> Move to cart</button>
                  <button data-testid={`wishlist-remove-${p.slug}`} onClick={() => toggleWishlist(p)} aria-label="Remove" className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-jute/80 transition-colors hover:border-sheesham hover:text-sheesham"><Trash2 className="h-4 w-4" /></button>
                </div>
              </motion.li>
            ))}
          </AnimatePresence>
        </ul>
      )}
    </div>
  );
}
